import React from 'react';
import axios from 'axios';
import StaticPageWrapper from "../StaticPageWrapper";
import { TextInput, TextArea, Button, Row } from '../../../components';
import styles from './styles.module.css';
import image from './contactUsBg.png';
import { useForm } from 'react-hook-form';
import { Col } from 'react-flexbox-grid';
import * as Icon from '../../../components/Icons'
import cn from 'classnames';

const Contact = () => {
  const { handleSubmit, register, errors } = useForm();

  const handleContactForm = async (data) => {
    await axios
      .post('/contact', data)
      .then((response) => {
        console.log(response);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  return (
    <StaticPageWrapper img={image} title={"Contact Us"} subscribe={false}>
      <Row>
        <Col lg={10} style={{ margin: "20px auto 60px auto" }}>
          <div className={styles.haveQuest}>Have questions</div>
          <p className={styles.title}>Talk to us</p>
          <p className={styles.text}>
            Umrahme is part of Traveazy Group that was established in 2014 to provide travel-related solutions to customers
            in GCC. Umrahme started as line of business within the Traveazy group (under the brand name of holidayme) and
            eventually became a standalone entity with a vision to provide Umrah related products to global travel agents &
            customers. We aspire to revolutionize the way in which Umrah travel is managed globally by bringing the Umrah
        ecosystem into an online platform which is dynamic, automated & backed up by AI.</p>
          <p className={cn(styles.smallTitle, styles.bottomLine)}>Leave a message</p>
          <div className={styles.contactForm}>
            <form onSubmit={handleSubmit(handleContactForm)}>
              <Row>
                <Col lg={6}>
                  <TextInput
                    name="name"
                    placeholder={'Name'}
                    register={register({ required: 'Required' })}
                    error={errors.name}
                    autocomplete="off"
                  />
                </Col>
                <Col lg={6}>
                  <TextInput
                    name="email"
                    type="email"
                    placeholder={'Email'}
                    register={register({ required: 'Required' })}
                    error={errors.email}
                    autocomplete="off"
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <TextInput
                    name="subject"
                    placeholder={'Subject'}
                    register={register({ required: 'Required' })}
                    error={errors.name}
                    autocomplete="off"
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={12}>
                  <TextArea
                    name="message"
                    placeholder={'Message'}
                    autocomplete="off"
                    register={register({ required: 'Required' })}
                    error={errors.message}
                  />
                </Col>
              </Row>
              <Row>
                <Button type="submit" className={cn(styles.sendBtn)}>Send Your Message</Button>
              </Row>
            </form>
          </div>
          <div style={{ clear: "both" }}></div>
          <div className={styles.addressInfo}>
            <div className={styles.info}>
              <div className={styles.icon}>
                <Icon.ContactPhone />
              </div>
              <div className={styles.infos}>
                <h3>Phone</h3>
                <p>+90 000 000 000</p>
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.icon}>
                <Icon.ContactPin />
              </div>
              <div className={styles.infos}>
                <h3>Address</h3>
                <p>Address Address Address Address Address</p>
              </div>
            </div>
            <div className={styles.info}>
              <div className={styles.icon}>
                <Icon.ContactMail />
              </div>
              <div className={styles.infos}>
                <h3>Email</h3>
                <p>info@hodhod.com</p>
              </div>
            </div>
          </div>
        </Col>
      </Row>

    </StaticPageWrapper>
  );
};

export default Contact;
